import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'gb-amex-icon',
  templateUrl: './gb-amex-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbAmexIconComponent {
  @Input() darkTheme = false
}
